module.exports = __webpack_public_path__ + "img/chat_system.3b91ff0a.png";